import React, { useState, useContext, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import ThemeContext from '../contexts/ThemeContext';
import CustomColorPicker from './CustomColorPicker';
import './Header.css';

const Header = () => {
  const { theme, setTheme } = useContext(ThemeContext);
  const [showThemeMenu, setShowThemeMenu] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const themeSelectorRef = useRef(null);
  const themeMenuRef = useRef(null);
  const [menuStyle, setMenuStyle] = useState({});

  // 计算菜单位置（移动端使用fixed定位）
  useEffect(() => {
    if (showThemeMenu && themeSelectorRef.current && themeMenuRef.current) {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        const rect = themeSelectorRef.current.getBoundingClientRect();
        const headerHeight = window.innerWidth <= 480 ? 70 : 80;
        setMenuStyle({
          position: 'fixed',
          top: `${headerHeight}px`,
          right: `${window.innerWidth - rect.right}px`,
        });
      } else {
        setMenuStyle({});
      }
    }
  }, [showThemeMenu]);

  // 点击外部关闭菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showThemeMenu &&
        themeSelectorRef.current &&
        !themeSelectorRef.current.contains(event.target)
      ) {
        setShowThemeMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [showThemeMenu]);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="机械宝宝ai" className="logo-icon" />
        </Link>
        
        <nav className="nav">
          <Link to="/" className="nav-link">首页</Link>
          <Link to="/ai-launcher" className="nav-link launcher-link">AI创作助手</Link>
          <Link to="/downloads" className="nav-link">资源中心</Link>
          <Link to="/community" className="nav-link">开源社区</Link>
          <Link to="/tutorials" className="nav-link">视频教程</Link>
        </nav>

        <div className="theme-selector" ref={themeSelectorRef}>
          <button 
            className="theme-btn"
            onClick={() => setShowThemeMenu(!showThemeMenu)}
            title="主题设置"
          >
            🎨
          </button>
          {showThemeMenu && (
            <div className="theme-menu" ref={themeMenuRef} style={menuStyle}>
              <button 
                className={theme === 'light' ? 'active' : ''}
                onClick={() => { setTheme('light'); setShowThemeMenu(false); }}
              >
                花粉女神主题
              </button>
              <button 
                className={theme === 'default' ? 'active' : ''}
                onClick={() => { setTheme('default'); setShowThemeMenu(false); }}
              >
                科技男神主题
              </button>
              <button 
                className={theme === 'custom' ? 'active' : ''}
                onClick={() => { setShowColorPicker(true); setShowThemeMenu(false); }}
              >
                自定义主题
              </button>
            </div>
          )}
          {showColorPicker && createPortal(
            <div className="color-picker-overlay" onClick={() => setShowColorPicker(false)}>
              <div onClick={(e) => e.stopPropagation()}>
                <CustomColorPicker onClose={() => setShowColorPicker(false)} />
              </div>
            </div>,
            document.body
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;

